import React, { useRef } from 'react';
import { Link } from 'react-router-dom';

import SearchBox from '../components/psc/lib/SearchBox'
import GncDataTable from '../components/psc/lib/GncDataTable'

import useUsergroupManagement from '../hooks/useUsergroupManagement'
import useTableSlots from '../hooks/useTableSlots'
import useBrowserTabTitle from '../hooks/useBrowserTabTitle'

const Usergroups = () => {
    useBrowserTabTitle('User Groups')

    const table = useRef(null)
    const localStorageOrderKey = 'tblUsergroupsOrder'
    const defaultOrder = [[ 0, 'asc' ]]

    const {
        usergroups,
    } = useUsergroupManagement()

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'name' },
        { data: 'user_count' },
        { data: 'roles' }
    ]

    const tableHead = (
        <tr>
            <th>Name</th>
            <th>Members</th>
            <th>Roles</th>
        </tr>
    )

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/usergroups/${row.id}`),
        2: (data, type, obj) => {
            if (!obj.roles) return ''
            return obj.roles
                .sort((a, b) => a.list_order > b.list_order)
                .map(r => r.full_name)
                .join(', ')
        }
    }

    return (
        <div className="wrapper wrapper-content">
            <div className="row">
                <div className="col-lg-12">
                    <div className="ibox float-e-margins">

                        <div className="ibox-title">
                            <h2>User Groups</h2>
                            <Link
                                className="btn btn-mr btn-primary" 
                                type="button"
                                to="/usergroups/new"
                            >
                                New User Group
                            </Link>
                        </div>

                        <div className="ibox-content">
                            <div className="row">
                                <SearchBox tableRef={table} />
                            </div>

                            <GncDataTable
                                    tableRef={table}
                                    data={usergroups}
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Usergroups
